import { Courtroom } from '@ftr/contracts/read'
import { generateUuid } from '@ftr/contracts/type/shared'
import { AbstractBuilder } from '@ftr/foundation'

export class CourtroomBuilder extends AbstractBuilder<Courtroom> {
  constructor() {
    super({
      id: generateUuid(),
      name: 'Courtroom',
      courtSystemId: generateUuid(),
      courthouse: undefined,
    })
  }
}
